import { push, ref, update } from "firebase/database";
import { database } from "../../../../Utils/firebase";
import GetSaleReturnDataFirebase from "../../SaleReturn/GetSaleReturnDataFirebase";

const EditAssignerUserSaleReturnDataInFirebase = async (state, dispatch, id, invoiceData, userId, ownerUid) => {
    if (!ownerUid) return null;



    try {

        const formatItems = (rawItems) => {
            return rawItems.map(i => ({
                // amount: i?.amount?.toString() || "0.00",
                // billId: invoiceData?.id?.toString() || "",
                // companyId: invoiceData?.companyId?.toString() || "",
                // creationDate: invoiceData.creationDate.toString() || new Date().getTime().toString(),
                // isSalesReturnKey: "",
                // itemId: "",
                // name: i?.name || "",
                // price: i?.price?.toString() || "",
                // quantity: i?.quantity?.toString() || "",
                // subtitle: i.subtitle || "",
                // updateDate: new Date().getTime().toString()
                itemId: i?.itemId?.toString() || "",
                itemAddedDate: new Date().getTime().toString() || "",
                price: i?.price?.toString() || "",
                quantity: i?.quantity?.toString() || "",
            }));
        };

        // Reference to user's invoice data
        const userRef = ref(database, `invoiceGenerator/users/${ownerUid}/returnInvoice/${id}`);

        // Push new invoice data
        await update(userRef, {
            updatedBy: state?.SET_USER?.name || state?.SET_USER?.email || state?.SET_USER?.contact || "guest",
            // address: invoiceData?.address?.toString() || "",
            // companyId: invoiceData?.companyId?.toString() || "",
            // creationDate: invoiceData.creationDate.toString() || new Date().getTime().toString(),
            // customInvoiceId: "",
            // customer: invoiceData?.customer?.toString() || "",
            // customerGSTNo: invoiceData?.customerGSTNo?.toString() || "",
            // date: invoiceData.creationDate.toString() || new Date().getTime().toString(),
            // discountAmount: invoiceData?.discountAmount?.toString() || "0.00",
            // discountPercetage: invoiceData?.discountPercetage?.toString() || "0",
            // dueDate: invoiceData?.dateDue.toString() || new Date().getTime().toString(),
            // email: invoiceData?.email.toString() || "",
            // gstAmount: invoiceData?.gstAmount?.toString() || "0.00",
            // pstAmount: invoiceData?.pstAmount?.toString() || "0.00",
            // pstPercentage: invoiceData?.pstPercentage?.toString() || "0",
            pstAmount: invoiceData?.pstAmount?.toString() || "0.00",
            pstPercentage: invoiceData?.pstPercentage?.toString() || "0",
            // gstPercetage: invoiceData?.gstPercentage?.toString() || "0",
            // id: invoiceData?.id?.toString() || "",
            // invoiceId: invoiceData?.invoiceId?.toString() || "",
            // isigst: invoiceData?.isigst ? "true" : "false",
            // items: formatItems(invoiceData?.items),
            // note: invoiceData?.note?.toString() || "",
            // paidFlagKey: invoiceData?.isPaid ? "true" : "false",
            // phone: invoiceData?.phone?.toString() || "",
            // totalAmount: invoiceData?.totalAmount?.toString() || "",
            // updateDate: new Date().getTime().toString(),
            // platform: "website",
            // version: 'website',
            companyId: invoiceData?.companyId?.toString() || "",
            creationDate: invoiceData?.creationDate?.toString() || new Date().getTime().toString(),
            customInvoiceId: invoiceData?.customInvoiceId?.toString() || "",
            customerId: invoiceData?.customerId?.toString(),
            date: invoiceData?.date?.toString() || "",
            discountAmount: invoiceData?.discountAmount?.toString() || "0.00",
            discountPercetage: invoiceData?.discountPercetage?.toString() || "0",
            dueDate: invoiceData?.dateDue?.toString() || new Date().getTime().toString(),
            gstAmount: invoiceData?.gstAmount?.toString() || "0.00",
            pstAmount: invoiceData?.pstAmount?.toString() || "0.00",
            pstPercentage: invoiceData?.pstPercentage?.toString() || "0",
            gstPercetage: invoiceData?.gstPercentage?.toString() || invoiceData?.gstPercetage?.toString() || "0",
            id: invoiceData?.id?.toString() || "",
            invoiceId: invoiceData?.invoiceId?.toString() || "",
            isigst: invoiceData?.isigst || invoiceData?.igst == true ? "true" : "false",
            note: invoiceData?.note?.toString() || "",
            paidFlagKey: invoiceData?.isPaid ? "true" : "false",
            platform: "website",
            version: process.env.REACT_APP_VERSION,
            totalAmount: invoiceData?.totalAmount?.toString() || "",
            updateDate: invoiceData?.creationDate?.toString() || new Date().getTime().toString(),
            items: formatItems(invoiceData?.items),
            reason: invoiceData?.reason?.toString() || ''
        });

        // Fetch updated invoice data
        await GetSaleReturnDataFirebase(state, dispatch);

        return { success: true, message: "Sale Return updated successfully!" };
    } catch (error) {
        return { success: false, message: error };
    }
};

export default EditAssignerUserSaleReturnDataInFirebase;
